import { render, staticRenderFns } from "./MapsPage.vue?vue&type=template&id=54275db4&scoped=true&lang=pug"
import script from "./MapsPage.vue?vue&type=script&lang=js"
export * from "./MapsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54275db4",
  null
  
)

export default component.exports